// import PersonRegistration from "../../../apis/PersonRegistration";
import Api from "../../../apis/Api";

export const personAdd = async ({ commit }, form_data) => {

    try {
        commit("LOADING", true);
        const response = await Api.post("/valid-member", form_data)
        if (response.status === 200) {
            console.log('23', response.data);
            commit("SET_VALIDATION", response.data);
            commit("SET_ADDRESS1_TEMP", response.data.address1);

            commit("LOADING", false);
        }
    } catch (error) {
        if (error.response.status == 422) {
            console.log('16', error)
            commit("LOADING", false);
            commit("NEW_ERROR", error.response.data.errors);
        }

    }


    commit("LOADING", false);


}

export const addMember = async ({ commit }, personPreviewData) => {
    try {
        commit("LOADING", true);
        const response = await Api.post("/add-member", personPreviewData)
        if (response.status === 200) {
            console.log('33', response.data);
            commit("SET_UID", response.data.uid);
            commit("SET_SUCCESS_MESSAGE", true);
            commit("LOADING", false);
        }

    } catch (error) {
        console.log('addMember action', error)
        commit("LOADING", false);
        commit("ERROR_PAGE_SHOW", true);
        commit("SET_SUCCESS_MESSAGE", null);

    }

    commit("LOADING", false);
}


export const showErrorMsEmpty = async ({ commit }, emptyError) => {

    commit("EMPTY_ERROR", emptyError);
    commit("PREVIEW_DATA_EMPTY", null);

}


export const clearError = async ({ commit }, emptyError) => {

    commit("EMPTY_ERROR", emptyError);

}